import { useMutation, useQuery } from "@tanstack/react-query";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "@/config/firebaseConfig";
import { BusinessData } from "@/types/businessData";

export default function useBusiness(uid: string) {
  return useQuery({
    queryKey: ["Businesses", uid],
    enabled: !!uid,
    queryFn: async () => {
      const docRef = doc(db, "Businesses", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return docSnap.data() as BusinessData;
      } else {
        throw new Error("Business not found");
      }
    },
  });
}

export function useCreateBusiness() {
  return useMutation({
    mutationFn: async ({ business, uid }: { business: any; uid: string }) => {
      return setDoc(doc(db, "Businesses", uid), {
        business: business.business,
        orgNumber: business.orgNumber,
        name: business.name,
        email: business.email,
        timestamp: serverTimestamp(),
        uid: uid,
        paid: false,
        v3: true,
        firstTimeOpening: true,
        accountType: "premium",
      });
    },
  });
}
